// HARIYANA

import banner1 from "../assets/landingpage/award-ceremonies/HARYANA/HARYANA-4.webp"
import banner2 from "../assets/landingpage/award-ceremonies/HARYANA/HARYANA-5.webp"
import banner3 from "../assets/landingpage/award-ceremonies/HARYANA/HARYANA-6.webp"
import banner4 from "../assets/landingpage/award-ceremonies/HARYANA/HARYANA-7.webp"
import banner5 from "../assets/landingpage/award-ceremonies/HARYANA/HARYANA-8.webp"
import banner6 from "../assets/landingpage/award-ceremonies/HARYANA/HARYANA-11.webp"

//HYDERABAD
import banner7 from "../assets/landingpage/award-ceremonies/HYDERABAD/HYD-3.webp"
import banner8 from "../assets/landingpage/award-ceremonies/HYDERABAD/HYD-5.webp"
import banner9 from "../assets/landingpage/award-ceremonies/HYDERABAD/HYD-14.webp"
import banner10 from "../assets/landingpage/award-ceremonies/HYDERABAD/HYD-15.webp"
import banner11 from "../assets/landingpage/award-ceremonies/HYDERABAD/HYD-17.webp"
import banner12 from "../assets/landingpage/award-ceremonies/HYDERABAD/HYD-19.webp"


//CHENNAI
import banner14 from "../assets/landingpage/award-ceremonies/CHENNAI/CHENNAI-1.webp"
import banner15 from "../assets/landingpage/award-ceremonies/CHENNAI/CHENNAI-2.webp"
import banner16 from "../assets/landingpage/award-ceremonies/CHENNAI/CHENNAI-5.webp"
import banner17 from "../assets/landingpage/award-ceremonies/CHENNAI/CHENNAI-6.webp"
import banner18 from "../assets/landingpage/award-ceremonies/CHENNAI/CHENNAI-7.webp"
import banner19 from "../assets/landingpage/award-ceremonies/CHENNAI/CHENNAI-8.webp"

//VIJAYAWADA
import banner20 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/VJA-1.webp"
import banner21 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/VJA-4.webp"
import banner22 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/VJA-5.webp"
import banner23 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/VJA-6.webp"
import banner24 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/VJA-9.webp"
import banner25 from "../assets/landingpage/award-ceremonies/VIJAYAWADA/VJA-11.webp"

//NELLORE

import banner26 from "../assets/landingpage/award-ceremonies/NLR/NLR-1.webp"
import banner27 from "../assets/landingpage/award-ceremonies/NLR/NLR-2.webp"
import banner28 from "../assets/landingpage/award-ceremonies/NLR/NLR-7.webp"
import banner29 from "../assets/landingpage/award-ceremonies/NLR/NLR-8.webp"
import banner30 from "../assets/landingpage/award-ceremonies/NLR/NLR-9.webp"
import banner31 from "../assets/landingpage/award-ceremonies/NLR/NLR-10.webp"

//BANGALORE

import banner32 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-1.JPG"
import banner33 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-2.JPG"
import banner34 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-7.JPG"
import banner35 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-10.JPG"
import banner36 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-24.JPG"
import banner37 from "../assets/landingpage/award-ceremonies/BENGALURU/BLR-40.JPG"




// Videos

export const awardImageGallery = [
 {
    caption: "Bengaluru",
    banners: [
      {
        id: 32,
        image: banner32,
      },
      {
        id: 33,
        image: banner33,
      },
      {
        id: 34,
        image: banner34,
      },
      {
        id: 35,
        image: banner35,
      },
      {
        id: 36,
        image: banner36,
      },
      {
        id: 37,
        image: banner37,
      }
    ]
  },
  {
    caption: "Haryana",
    banners: [
      {
        id: 1,
        image: banner1,
      },
      {
        id: 2,
        image: banner2,
      },
      {
        id: 3,
        image: banner3,
      },
      {
        id: 4,
        image: banner4,
      },
      {
        id: 5,
        image: banner5,
      },
      {
        id: 6,
        image: banner6,
      },
    ],
  },
  {
    caption: "Hyderabad",
    banners: [
      {
        id: 7,
        image: banner7,
      },
      {
        id: 8,
        image: banner8,
      },
      {
        id: 9,
        image: banner9,
      },
      {
        id: 10,
        image: banner10,
      },
      {
        id: 11,
        image: banner11,
      },
      {
        id: 12,
        image: banner12,
      },
    ],
  },
  {
    caption: "Chennai",
    banners: [
      {
        id: 14,
        image: banner14,
      },
      {
        id: 15,
        image: banner15,
      },
      {
        id: 16,
        image: banner16,
      },
      {
        id: 17,
        image: banner17,
      },
      {
        id: 18,
        image: banner18,
      },
      {
        id: 19,
        image: banner19,
      },
    ],
  },
  {
    caption: "Vijayawada",
    banners: [
      {
        id: 20,
        image: banner20,
      },
      {
        id: 21,
        image: banner21,
      },
      {
        id: 22,
        image: banner22,
      },
      {
        id: 23,
        image: banner23,
      },
      {
        id: 24,
        image: banner24,
      },
      {
        id: 25,
        image: banner25,
      },
    ],
  },
  {
    caption: "Nellore",
    banners: [
      {
        id: 26,
        image: banner26,
      },
      {
        id: 27,
        image: banner27,
      },
      {
        id: 28,
        image: banner28,
      },
      {
        id: 29,
        image: banner29,
      },
      {
        id: 30,
        image: banner30,
      },
      {
        id: 31,
        image: banner31,
      },
    ]
  }
];

export const videoGallery = [
  {
    id: 4,
    caption: "CNAPS Toppers Feedback",
    youtubeLink: "https://youtu.be/bWoGGAaf7cQ",
  },
  {
    id: 2,
    caption: "Hyderabad",
    youtubeLink: "https://youtu.be/xuYyyd4WPlU",
  },
  {
    id: 1,
    caption: "Haryana",
    youtubeLink: "https://youtu.be/Uz9h4mgG7Sk",
  },
  {
    id: 3,
    caption: "Chennai",
    youtubeLink: "https://youtu.be/vrUpJfFvdpI",
  },{
    id: 3,
    caption: "Vijayawada",
    youtubeLink : "https://youtu.be/d8on7mUGnuM",
  },
  {
    id: 3,
    caption: "Nellore",
    youtubeLink : "https://youtu.be/LVBk5gbBv9w",
  },
];
